/**
 * How the surface around a conversation opens another one in its place: the simple view swaps its `?c=` selection,
 * the detailed view navigates to `/conversations/:id`. A member's thread in the records list, and a conversation a
 * record's screen launches from inside a side panel, open through it (owner 2026-10-31: "open that specific
 * conversation in the same view").
 */
import { createContext, useContext } from 'react';

export const OpenConversationContext = createContext<((conversationId: string) => void) | null>(null);

/** The surface's way to open a conversation in place; null outside a conversation surface. */
export function useOpenConversation(): ((conversationId: string) => void) | null {
  return useContext(OpenConversationContext);
}
